/**
 * Evita home/cabeçalho antigos ao usar Voltar (bfcache + View Transitions).
 * Compara versão do tema na página em cache com a última visitada na sessão.
 */
(function () {
  const META_NAME = 'vestfirma-theme-build';
  const storageKey = () => 'vestfirma-theme-build-latest';

  function getPageBuild() {
    return (
      document.documentElement.getAttribute('data-vestfirma-build') ||
      document.querySelector(`meta[name="${META_NAME}"]`)?.getAttribute('content') ||
      ''
    );
  }

  function isDesignMode() {
    return document.documentElement.classList.contains('shopify-design-mode');
  }

  function syncLatestBuild() {
    const build = getPageBuild();
    if (!build) return;
    try {
      sessionStorage.setItem(storageKey(), build);
    } catch (_) {
      /* private mode */
    }
  }

  function isStaleCachedPage() {
    const pageBuild = getPageBuild();
    let latest = '';
    try {
      latest = sessionStorage.getItem(storageKey()) || '';
    } catch (_) {
      return false;
    }

    if (!pageBuild) return true;
    if (latest && latest !== pageBuild) return true;
    return false;
  }

  function refreshIfRestoredFromCache(event) {
    if (isDesignMode() || !event.persisted) return;
    if (isStaleCachedPage()) {
      window.location.reload();
    }
  }

  syncLatestBuild();

  window.addEventListener('pageshow', refreshIfRestoredFromCache);
  window.addEventListener('pagereveal', refreshIfRestoredFromCache);
})();
